import { NgModule } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { TabGroupComponent } from './tab-group.component';
import { TabComponent } from './tab.component';

/**
 * Module that exports {@link TabGroupComponent} and {@link TabComponent}.
 *
 * @remarks
 * This module provides the tab component suite for displaying tabbed content interfaces.
 * Import this module into your Angular module to use the `bb-tab-group-ui` and `bb-tab-ui` components.
 *
 * @example
 *
 * ```typescript
 * import { TabModule } from '@backbase/ui-ang/tab';
 *
 * @NgModule({
 *   imports: [TabModule]
 * })
 * export class MyModule {}
 * ```
 */
@NgModule({
  imports: [NgClass, NgTemplateOutlet],
  declarations: [TabGroupComponent, TabComponent],
  exports: [TabGroupComponent, TabComponent],
})
export class TabModule {}
